import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';

interface VideoGridProps {
  videos: Video[];
}

export default function VideoGrid({ videos }: VideoGridProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
      {videos.map((video) => (
        <Link
          key={video.id}
          to={`/category/${video.category}`}
          className="group cursor-pointer"
        >
          <div className="relative overflow-hidden rounded-lg aspect-video bg-background-200">
            <img
              src={video.thumbnail}
              alt={video.title}
              title={`${video.title} - 芭乐视频高清在线观看`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              loading="lazy"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
              <div className="flex items-center gap-2">
                <span className="text-xs text-white/90 bg-black/40 px-1.5 py-0.5 rounded">{video.duration}</span>
                <span className="text-xs text-white/90 bg-primary-500/80 px-1.5 py-0.5 rounded">{video.quality}</span>
              </div>
            </div>
            <div className="absolute top-2 right-2">
              <span className="text-xs text-white bg-black/50 px-1.5 py-0.5 rounded">{video.views}次播放</span>
            </div>
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
              <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-play-fill text-white text-xl"></i>
              </div>
            </div>
          </div>
          <div className="mt-2.5 px-0.5">
            <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
              {video.title}
            </h3>
            <div className="flex items-center gap-2 mt-1">
              <span className="text-xs text-foreground-500">{video.year}</span>
              <span className="text-xs text-foreground-400">|</span>
              <div className="flex items-center gap-0.5">
                <i className="ri-star-fill text-accent-500 text-xs"></i>
                <span className="text-xs text-foreground-600">{video.rating}</span>
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}